import {
  Button,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icons,
} from '@commenda/kakashi';
import { PlanCategory, PlanDetailsResponse } from '../../types';

interface PlanDetailsStepProps {
  onClose: () => void;
  name: string;
  category: PlanCategory;
  price: number;
  billingCycle: string;
  nextPaymentDue?: string;
  features: string[];
  planDetails?: PlanDetailsResponse;
}

export const PlanDetailsStep = ({
  onClose,
  name,
  price,
  billingCycle,
  nextPaymentDue,
  features,
  planDetails,
}: PlanDetailsStepProps) => {
  const displayFeatures = planDetails?.features || features;

  return (
    <div className="max-w-[676px] h-fit rounded-lg border border-border-secondary shadow-3xl">
      <DialogHeader>
        <DialogTitle>View Plan Details</DialogTitle>
      </DialogHeader>

      <div className="p-3xl space-y-3xl">
        <div className="bg-utility-violet-50 rounded-lg gap-xl p-2xl">
          <div className="space-y-md">
            <h2 className="text-xl-bold text-text-primary">{name}</h2>
            <div className="text-sm-regular text-text-tertiary">
              Billed {billingCycle} • Next payment due on {nextPaymentDue}
            </div>
          </div>
          <div className="flex items-baseline space-y-xl">
            <span className="text-md-bold text-text-primary">${price}</span>
            <span className="text-sm-regular text-text-tertiary ml-1">
              /year
            </span>
          </div>
        </div>

        <div className="space-y-xl">
          <h2 className="text-xl-bold text-text-primary">Included</h2>

          <ul className="space-y-3">
            {displayFeatures.map((feature, index) => (
              <li key={index} className="flex items-start gap-3">
                <Icons.Check className="h-5 w-5 text-fg-success" />
                <span className="text-sm-regular text-text-secondary">
                  {feature}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <DialogFooter>
        <Button variant="primary" size="md" onClick={onClose}>
          Close
        </Button>
      </DialogFooter>
    </div>
  );
};

export default PlanDetailsStep;
